import ReactTooltip from "react-tooltip";
import Division from "../../../components/Division";
import Header from "../../../components/Header";
import Lateral from "../../../components/Lateral";
import Title from "../../../components/Title";
import { FaCog } from "react-icons/fa";

export default function ReportsBasePage({carrying, title, qtdePage, children, choosePageTypes, pageType, pageTypes}){
    return (
        <div>
            <Header />
            <Division />
            <Lateral />
            <ReactTooltip />

            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando..</span>
                    <FaCog icon="spinner" className="spinner" />
                </div>
            </div>}
            {!carrying && <div className="content">
                <div className="title" style={{display: "flex", justifyContent: "space-between"}}>
                    <span>{title}</span>
                            <div>
                                {(!choosePageTypes || (choosePageTypes && pageType?.state)) && <select className='selectQtdeItens' value={qtdePage.state} onChange={(e) => qtdePage.setState(e.target.value)}>
                                    <option value="1000">Itens por página</option>
                                    <option value="10">10</option>
                                    <option value="50">20</option>
                                    <option value="100">30</option>
                                    <option value="500">40</option>
                                    <option value="1000">50</option>
                                </select>}
                                {choosePageTypes &&
                                    <div style={{display: "flex", alignItems: "center", gap: "0.5rem"}}>
                                        <label style={{fontWeight: "400"}}>Selecione um modelo:</label>
                                        <select className='selectQtdeItens' value={pageType?.state} onChange={(event) => pageType?.setState(event.target.value)}>
                                            {pageTypes?.state?.map((pageType, index) => {
                                                return (
                                                    <option value={pageType?.value} key={index}>{pageType?.label}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                }
                            </div>
                    </div>
                    <div className="container">{children}</div>
                </div>
            }
        </div>
    )
}